import { call, put, takeEvery, select } from 'redux-saga/effects';
import { replace } from 'connected-react-router';
import {
  employeesSuccess,
  employeesFailure,
  createEmployeeSuccess,
  createEmployeeFailure,
  updateEmployeePasswordSuccess,
  updateEmployeePasswordFailure,
  deleteEmployeeSuccess,
  deleteEmployeeFailure,
} from './actions';
import {
  EMPLOYEES_REQUEST,
  CREATE_EMPLOYEE_REQUEST,
  UPDATE_EMPLOYEE_PASSWORD_REQUEST,
  DELETE_EMPLOYEE_REQUEST,
} from './actionTypes';
import UserService from '../../services/UserService';
import { getCurrentUser as getCurrentUserSelector } from './selectors';
import { logoutRequest } from '../auth/actions';

export function* getEmployeesTask() {
  try {
    const list = yield call(UserService.getEmployees);
    yield put(employeesSuccess(list));
  } catch (error) {
    yield put(employeesFailure(error));
  }
}

export function* createEmployeeTask(action) {
  try {
    const params = action.payload;
    const employee = yield call(UserService.createEmployee, params);
    yield put(createEmployeeSuccess(employee));
    yield put(replace('/employees'));
  } catch (error) {
    yield put(createEmployeeFailure(error));
  }
}

export function* updateEmployeePasswordTask(action) {
  try {
    const params = action.payload;
    yield call(UserService.updateEmployeePassword, params);
    yield put(updateEmployeePasswordSuccess());
    // if the employee changed their own password, do a full reload and go to the home page to clear out the (now invalid) access token
    const currentEmployee = yield select(getCurrentUserSelector);
    if (params.email === currentEmployee.email) {
      yield put(logoutRequest());
    } else {
      yield put(replace('/employees'));
    }
  } catch (error) {
    yield put(updateEmployeePasswordFailure(error));
  }
}

export function* deleteEmployeeTask(action) {
  try {
    const userId = action.payload;
    yield call(UserService.deleteUser, userId);
    yield put(deleteEmployeeSuccess(userId));
  } catch (error) {
    yield put(deleteEmployeeFailure(error));
  }
}

export function* employeeSaga() {
  yield takeEvery(EMPLOYEES_REQUEST, getEmployeesTask);
  yield takeEvery(CREATE_EMPLOYEE_REQUEST, createEmployeeTask);
  yield takeEvery(UPDATE_EMPLOYEE_PASSWORD_REQUEST, updateEmployeePasswordTask);
  yield takeEvery(DELETE_EMPLOYEE_REQUEST, deleteEmployeeTask);
}
